import { ViewCell } from '@theme/components/grid/ng2-smart-table/components/cell/cell-view-mode/view-cell';
import { OnInit, Input, Component } from '@angular/core';
import { Router } from '@angular/router';
import  moment from 'moment';
import { of } from 'rxjs';

@Component({
    selector: 'navigation-link-cell',
    template: `
    <a *ngIf="!isDeleted" class="{{navigationLink ? 'link' : ''}}" (click)="onClick()">
      {{ this.value }}
    </a>
    <p *ngIf="isDeleted" data-html="true"
      nbTooltipStatus="control" [nbTooltip]="this.deletedMessage"
      nbTooltipClass="toolTip" nbTooltipPlacement="bottom" >
      {{ this.value }}
    </p>
  `,
    styleUrls: ['./navigation-link-cell.component.scss'],
    standalone: false
})
export class NavigationLinkCellComponent implements ViewCell, OnInit {
  renderValue: string;

  @Input() value: string | number;
  @Input() status: string | number;
  @Input() rowData: any;
  @Input() settings: any;

  fromDate: moment.Moment = moment();
  toDate = moment().add(7, 'days');

  isDeleted = false;
  deletedMessage: string;
  navigationLink: string;
  navigationBy: string;
  fromDateString: string;
  toDateString: string;
  isOpenNewPage: boolean;
  isOpenTenantLink: boolean;

  constructor(private router: Router) {

  }

  ngOnInit() {
    this.navigationLink = this.settings.navigationLink;
    this.navigationBy = this.settings.navigationBy;
    this.isOpenNewPage = this.settings.isOpenNewPage;
    this.isOpenTenantLink = this.settings.isOpenTenantLink;
    this.isDeleted = this.rowData[this.settings.isDeletedField];
    this.deletedMessage = this.settings.deletedMessage;
  }

  // Set FromDate on Mon, ToDate on Sunday when user select a date
  fillInDate() {
    // When use navigate from customer/invoice, user want to see deliveries in invoice date
    this.fromDate = this.settings.targetDate != null
      ? moment(this.rowData[this.settings.targetDate])
      : moment();

    this.fromDate = moment(this.fromDate.day(1));


    if (this.navigationLink.includes('/routes/')) {
      var endDate = this.rowData['endDate'];
      if (endDate) {
        if (moment(endDate) < moment()) {
          this.fromDate = moment(endDate).add(-6, 'days');
        }
      }
    }

    this.toDate = moment(this.fromDate).add(6, 'days');
    this.toDateString = this.toDate.toISOString();
    this.fromDateString = this.fromDate.toISOString();  
    // Convert to ISOString
  }

  onClick() {
    if (this.navigationLink) {
      if (this.isOpenNewPage) {
        let url = this.navigationLink;
        if (this.isOpenTenantLink) {
          url = `${window.location.protocol}//${this.value}.${url}`;
        }
        window.open(url, "_blank");
      }
      else {
        if (this.navigationLink.includes('/routes/')) {
          this.fillInDate();

          this.router.navigate([`${this.navigationLink}/${this.rowData[this.navigationBy]}/${this.fromDateString}/${this.toDateString}`]);
        } else {
          this.router.navigate([`${this.settings.navigationLink}/${this.rowData[this.settings.navigationBy]}`]);
        }
      }
    }
  }

  getMonday(d) {
    d = new Date(d);
    var day = d.getDay(),
      diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    return new Date(d.setDate(diff));
  }
}
